import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function TermsPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-2518">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2519">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2520">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2521">
            <Link to="/" data-id="element-2522">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2523" />
            </Link>
            <Navigation data-id="element-2524" />
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="pt-32 pb-24 px-6 md:px-12 lg:px-24" data-id="element-2525">
        <div className="max-w-4xl mx-auto" data-id="element-2526">
          <h1 className="text-5xl md:text-6xl font-bold mb-16 font-['Syne'] text-black" data-id="element-2527">
            TERMS OF SERVICES
          </h1>

          <div className="space-y-12 font-['Lora'] text-gray-800 leading-relaxed" data-id="element-2528">
            <section data-id="element-2529">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2530">
                1. Overview
              </h2>
              <p className="text-lg mb-4" data-id="element-2531">
                Welcome to MeetSynthia.ai ("Synthia," "we," "us," or "our").
                These Terms and Conditions ("Terms") govern your access to and
                use of our website, products, and services (collectively, the
                "Platform").
              </p>
              <p className="text-lg" data-id="element-2532">
                By accessing or using the Platform, you agree to be bound by
                these Terms and our Privacy Policy. If you do not agree,
                discontinue use immediately.
              </p>
            </section>

            <section data-id="element-2533">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2534">
                2. Nature of the Service
              </h2>
              <p className="text-lg mb-4" data-id="element-2535">
                MeetSynthia.ai provides an AI-driven instruction layer that
                augments, governs, and optimizes user and agentic inputs ("prompts") for
                compatibility with large language models ("LLMs").
              </p>
              <p className="text-lg mb-4" data-id="element-2536">
                Synthia operates exclusively at the instruction layer. We do not
                generate, produce, or provide final AI outputs. All generative
                content, answers, and responses are produced entirely by
                external frontier AI models (e.g., OpenAI, Anthropic, Google, or
                your chosen enterprise LLM).
              </p>
              <p className="text-lg" data-id="element-2537">
                Synthia's role is limited to preparing, governing, structuring,
                and verifying prompt instructions using configurable
                "guardrails," "attributes," "roles," and "workflows."
              </p>
            </section>

            <section data-id="element-2538">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2539">
                3. No Responsibility for AI Output
              </h2>
              <p className="text-lg mb-4" data-id="element-2540">
                Because Synthia operates solely at the instruction layer and
                does not produce final answers, you explicitly acknowledge and
                agree that:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2541">
                <li data-id="element-2542">
                  Synthia is not responsible for any content, answers, or
                  outputs generated by third-party AI systems.
                </li>
                <li data-id="element-2543">
                  Synthia makes no warranties, representations, or guarantees as
                  to the accuracy, completeness, legality, reliability, safety,
                  or appropriateness of AI-generated outputs.
                </li>
                <li data-id="element-2544">
                  Synthia cannot and does not make claims regarding security,
                  PII handling, bias mitigation, or factual accuracy of final
                  outputs—these are determined entirely by the frontier LLM
                  provider.
                </li>
                <li data-id="element-2545">
                  You agree to independently review, verify, and validate all
                  AI-generated results before use, publication, or reliance.
                </li>
                <li data-id="element-2546">
                  Any issues related to output quality, hallucinations, bias,
                  toxicity, or compliance violations are the sole responsibility
                  of the AI model provider and the user.
                </li>
              </ul>
            </section>

            <section data-id="element-2547">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2548">
                4. Enterprise Hosting and Data Handling
              </h2>
              <p className="text-lg mb-4" data-id="element-2549">
                When deployed in an enterprise environment, Synthia may be
                hosted:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2550">
                <li data-id="element-2551">
                  Privately within the client's infrastructure (self-hosted,
                  on-premises, or VPC), or
                </li>
                <li data-id="element-2552">In Synthia's secure managed cloud environment.</li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2553">In both cases:</p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2554">
                <li data-id="element-2555">
                  The enterprise retains full ownership of its data, prompts,
                  guardrails, workflows, and all proprietary configurations.
                </li>
                <li data-id="element-2556">
                  Synthia processes data solely for the purpose of providing,
                  improving, and supporting the Platform.
                </li>
                <li data-id="element-2557">
                  Synthia will never sell, monetize, or use client data for
                  model training, marketing, or competitive purposes.
                </li>
                <li data-id="element-2558">
                  Client-specific proprietary information, including custom
                  guardrails, unique workflows, domain expertise, and
                  institutional knowledge extracted from your organization, will
                  never be shared with third parties or other customers.
                </li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2559">
                Data sharing with third parties occurs only:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2560">
                <li data-id="element-2561">With the client's explicit written consent, or</li>
                <li data-id="element-2562">As required by law, court order, or lawful subpoena.</li>
              </ul>
            </section>

            <section data-id="element-2563">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2564">
                5. Marketplace and Contextual Intelligence Catalog
              </h2>
              <p className="text-lg mb-4" data-id="element-2565">
                Synthia operates a marketplace of contextual intelligence that
                includes:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2566">
                <li data-id="element-2567">
                  Pre-built guardrails, roles, attributes, and workflows
                  developed by Synthia.
                </li>
                <li data-id="element-2568">Community-contributed and third-party components.</li>
                <li data-id="element-2569">Industry best practices and common governance patterns.</li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2570">
                You acknowledge and agree that:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2571">
                <li data-id="element-2572">
                  Best practices, industry standards, and common governance
                  patterns naturally overlap across organizations and cannot be
                  considered proprietary to any single client.
                </li>
                <li data-id="element-2573">
                  While your proprietary and confidential information will never
                  be shared, Synthia may develop similar or related guardrails,
                  workflows, or governance patterns for other clients based on
                  industry knowledge, public information, and independent
                  development.
                </li>
                <li data-id="element-2574">
                  No client has exclusive rights to general concepts,
                  approaches, or methodologies in AI governance.
                </li>
                <li data-id="element-2575">
                  The marketplace may contain components similar to those
                  developed for your organization, reflecting common industry
                  needs rather than disclosure of your proprietary information.
                </li>
                <li data-id="element-2576">
                  You cannot claim ownership or exclusive rights over
                  industry-standard practices, common use cases, or generally
                  applicable governance frameworks.
                </li>
                <li data-id="element-2577">
                  Synthia commits that any components in the marketplace derived
                  from work with specific clients will be sufficiently
                  abstracted and generalized to remove client-specific
                  proprietary information, trade secrets, and confidential
                  business logic.
                </li>
              </ul>
            </section>

            <section data-id="element-2578">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2579">
                6. License and Acceptable Use
              </h2>
              <p className="text-lg mb-4" data-id="element-2580">
                You are granted a limited, revocable, non-exclusive license to
                use the Platform for internal business purposes. You may not:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2581">
                <li data-id="element-2582">
                  Use the Platform for unlawful, infringing, or harmful
                  activity.
                </li>
                <li data-id="element-2583">
                  Reverse engineer, decompile, or modify any part of the
                  Platform.
                </li>
                <li data-id="element-2584">
                  Attempt to access another customer's data, configurations, or
                  restricted systems.
                </li>
                <li data-id="element-2585">
                  Use the Platform to generate content that violates applicable
                  laws or third-party rights.
                </li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2586">
                We reserve the right to suspend or terminate access for
                violations of these Terms.
              </p>
            </section>

            <section data-id="element-2587">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2588">
                7. Intellectual Property
              </h2>
              <p className="text-lg mb-4" data-id="element-2589">
                All intellectual property in the Platform, including software,
                base guardrail logic, BrandKey™ technology, visual interfaces,
                documentation, and core architecture, belongs to MeetSynthia,
                Inc. or its licensors.
              </p>
              <p className="text-lg mb-2" data-id="element-2590">Users retain ownership of:</p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2591">
                <li data-id="element-2592">Their original data and prompts.</li>
                <li data-id="element-2593">Custom guardrails and configurations they create.</li>
                <li data-id="element-2594">Proprietary workflows and institutional knowledge.</li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2595">
                By using the Platform, you grant Synthia a limited,
                non-exclusive right to process, host, and analyze your
                configurations solely to provide and improve the service. This
                license terminates upon account closure, subject to retention
                periods specified in our Privacy Policy.
              </p>
            </section>

            <section data-id="element-2596">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2597">
                8. Third-Party Integrations
              </h2>
              <p className="text-lg mb-4" data-id="element-2598">
                Synthia integrates with external AI providers and enterprise
                systems at your direction. You acknowledge that:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2599">
                <li data-id="element-2600">
                  We are not responsible for third-party systems, their
                  availability, performance, uptime, or outputs.
                </li>
                <li data-id="element-2601">
                  You must comply with all applicable third-party terms of
                  service (e.g., OpenAI API Terms, Anthropic Terms, Google Cloud
                  Terms).
                </li>
                <li data-id="element-2602">
                  Any issues with AI model performance, availability, or outputs
                  must be addressed with the respective provider.
                </li>
              </ul>
            </section>

            <section data-id="element-2603">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2604">
                9. Disclaimers
              </h2>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2605">
                THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT
                WARRANTY OF ANY KIND.
              </p>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2606">
                WE EXPRESSLY DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED,
                INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, ACCURACY,
                RELIABILITY, OR SECURITY.
              </p>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2607">
                NO ADVICE OR INFORMATION OBTAINED FROM SYNTHIA SHALL CREATE ANY
                WARRANTY NOT EXPRESSLY STATED IN THESE TERMS.
              </p>
              <p className="text-lg uppercase font-bold" data-id="element-2608">
                ALL AI OUTPUTS MUST BE REVIEWED BY QUALIFIED HUMANS BEFORE USE.
                AUTOMATED RELIANCE ON AI OUTPUTS IS DONE AT YOUR SOLE RISK.
              </p>
            </section>

            <section data-id="element-2609">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2610">
                10. Limitation of Liability
              </h2>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2611">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2612">
                <li data-id="element-2613">
                  MeetSynthia shall not be liable for any indirect, incidental,
                  consequential, special, exemplary, or punitive damages,
                  including but not limited to loss of profits, data, use,
                  goodwill, or other intangible losses.
                </li>
                <li data-id="element-2614">
                  Our total aggregate liability for any claim shall not exceed
                  the total amount paid to MeetSynthia in the six (6) months
                  immediately preceding the claim, or $100 USD, whichever is
                  greater.
                </li>
                <li data-id="element-2615">
                  This limitation applies regardless of the theory of liability
                  (contract, tort, negligence, strict liability, or otherwise)
                  and even if we have been advised of the possibility of such
                  damages.
                </li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2616">
                Given that Synthia operates solely at the instruction layer and
                all outputs are produced by third-party AI systems, MeetSynthia
                cannot be held responsible for any damages resulting from
                AI-generated content, including but not limited to
                misinformation, bias, harmful content, privacy violations,
                regulatory non-compliance, or financial losses.
              </p>
            </section>

            <section data-id="element-2617">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2618">
                11. Indemnification
              </h2>
              <p className="text-lg mb-4" data-id="element-2619">
                You agree to indemnify, defend, and hold harmless MeetSynthia,
                its affiliates, officers, directors, employees, agents, and
                licensors from and against any and all claims, liabilities,
                damages, losses, costs, expenses, or fees (including reasonable
                attorneys' fees) arising from:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2620">
                <li data-id="element-2621">Your use or misuse of the Platform.</li>
                <li data-id="element-2622">Your violation of these Terms.</li>
                <li data-id="element-2623">Your violation of any rights of another party.</li>
                <li data-id="element-2624">
                  Content generated by third-party AI systems that you deploy,
                  publish, or rely upon.
                </li>
                <li data-id="element-2625">
                  Any breach of your representations or warranties herein.
                </li>
              </ul>
            </section>

            <section data-id="element-2626">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2627">
                12. Compliance with Data Protection Laws
              </h2>
              <p className="text-lg mb-4" data-id="element-2628">
                Each party shall comply with all applicable data protection
                laws, including but not limited to the General Data Protection
                Regulation (GDPR), California Consumer Privacy Act (CCPA),
                Health Insurance Portability and Accountability Act (HIPAA)
                where applicable, and other relevant frameworks.
              </p>
              <p className="text-lg" data-id="element-2629">
                When Synthia acts as a data processor, we process data only
                under the written instructions of the data controller (the
                client). Clients are responsible for ensuring their use of the
                Platform complies with all applicable regulations.
              </p>
            </section>

            <section data-id="element-2630">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2631">
                13. Termination
              </h2>
              <p className="text-lg mb-4" data-id="element-2632">
                MeetSynthia may suspend or terminate your access at any time
                for:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2633">
                <li data-id="element-2634">Violation of these Terms.</li>
                <li data-id="element-2635">Non-payment of fees.</li>
                <li data-id="element-2636">Engagement in fraudulent, harmful, or illegal activity.</li>
                <li data-id="element-2637">Court order or legal requirement.</li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2638">
                Upon termination, you must immediately cease all use of the
                Platform. Data retention and deletion procedures are governed by
                our Privacy Policy and any applicable Data Processing Agreement.
              </p>
            </section>

            <section data-id="element-2639">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2640">
                14. Governing Law and Dispute Resolution
              </h2>
              <p className="text-lg mb-4" data-id="element-2641">
                These Terms are governed by and construed in accordance with the
                laws of the State of Delaware, United States, without regard to
                its conflict of law provisions.
              </p>
              <p className="text-lg" data-id="element-2642">
                Any disputes arising from or relating to these Terms or the
                Platform shall be resolved exclusively in the state or federal
                courts located in Delaware. You consent to the personal
                jurisdiction of such courts.
              </p>
            </section>

            <section data-id="element-2643">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2644">
                15. Changes to Terms
              </h2>
              <p className="text-lg mb-4" data-id="element-2645">
                We reserve the right to modify these Terms at any time. Changes
                will be effective upon posting to the website with a new "Last
                Updated" date. Your continued use of the Platform after changes
                are posted constitutes acceptance of the revised Terms.
              </p>
            </section>

            <section data-id="element-2646">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2647">
                16. Severability
              </h2>
              <p className="text-lg" data-id="element-2648">
                If any provision of these Terms is found to be unenforceable or
                invalid, that provision shall be limited or eliminated to the
                minimum extent necessary, and the remaining provisions shall
                remain in full force and effect.
              </p>
            </section>

            <section data-id="element-2649">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2650">
                17. Entire Agreement
              </h2>
              <p className="text-lg" data-id="element-2651">
                These Terms, together with our Privacy Policy and any applicable
                Data Processing Agreement, constitute the entire agreement
                between you and MeetSynthia regarding the Platform and supersede
                all prior or contemporaneous understandings and agreements.
              </p>
            </section>

            <section data-id="element-2652">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2653">
                18. Contact
              </h2>
              <p className="text-lg mb-4" data-id="element-2654">For questions about these Terms:</p>
              <p className="text-lg" data-id="element-2655">📧 legal@meetsynthia.ai</p>
              <p className="text-lg mt-4" data-id="element-2656">
                MeetSynthia, Inc.
                <br data-id="element-2657" />
                Wilmington, Delaware, USA
              </p>
              <p className="text-lg mt-6" data-id="element-2658">Last Updated: December 26, 2024</p>
            </section>
          </div>
        </div>
      </main>

      <Footer data-id="element-2659" />
    </div>;
}